module.exports = {"title":"Our Weekly Updates","body":"<p>This page will be used to document weekly progress.</p>\n"}


//////////////////
// WEBPACK FOOTER
// ./process/index.md
// module id = 491
// module chunks = 0